module.exports = __webpack_public_path__ + "img/logo_xs.5347ac.svg";